// Component: Select.jsx
// Purpose: DS native <select> — `.ds-input.ds-select` (custom chevron, appearance
//   reset). Same field wrapper (label/hint/error) + size as Input. Options are
//   passed as children (<option>). Ref-forwarded.

import React, { forwardRef, useId } from "react";
import { cx } from "./cx";

const SIZES = { sm: "sm", md: "", lg: "lg" };

export const Select = forwardRef(function Select(
  { label, hint, error, size = "md", id, className, invalid, children, ...props },
  ref
) {
  const reactId = useId();
  const inputId = id || reactId;
  const isInvalid = invalid || Boolean(error);

  const selectEl = (
    <select
      ref={ref}
      id={inputId}
      className={cx("ds-input", "ds-select", SIZES[size], className)}
      aria-invalid={isInvalid || undefined}
      {...props}
    >
      {children}
    </select>
  );

  if (label == null && hint == null && error == null) return selectEl;

  return (
    <div className="ds-field">
      {label != null && <label htmlFor={inputId}>{label}</label>}
      {selectEl}
      {error != null ? (
        <div className="ds-field-err">{error}</div>
      ) : hint != null ? (
        <div className="ds-field-hint">{hint}</div>
      ) : null}
    </div>
  );
});

export default Select;
